import axios from 'axios';
import {add2basket, removefromfv} from './basket';
import {add2basketfromco} from './checkout';
import * as EmailValidator from 'email-validator';

import {
  defaultMaxItemWith,
  sliderMaxItems,
  sliderViewportWSwitch,
  touchEnabled,
  Flag,
  rootUrl,
  lazyLoadProdImg,
  lazyLoadCntImg
} from './config';
import globalEvent from "./eventEmitter";

var sliderList = sliderList || {};
var h = React.createElement;

function storePaging2Session(data) {
  var pageKey=`paging_${document.location.pathname}`;
  window.sessionStorage.setItem(pageKey, JSON.stringify(data));
}

function getPagingFromSession(pKey) {
  if (!window.sessionStorage) return null;
  var data = window.sessionStorage.getItem(pKey);
  if (data) {
    window.sessionStorage.removeItem(pKey);
    try{
      data = JSON.parse(data);
    }catch(err){
      data=null;
    }
  }
  return data;
}

function storeProductNavigationSession(event, href) {
  let ele = $(event.target).parents().siblings().closest("div.product-nav-all");
  if (!ele) return;
  const productNavs = JSON.stringify(JSON.parse(ele.text()));
  if (!productNavs.length) return;
  var url = null;
  try {
    url = new URL(href);
  } catch (e) {
    console.error(e)
  }
  window.sessionStorage.setItem(`nav_${url.pathname ? url.pathname : href}`, productNavs);
}

function getProductNavigationSession(navKey) {
  if (!window.sessionStorage) return null;
  var data = window.sessionStorage.getItem(navKey);
  if (data) {
    try {
      data = JSON.parse(data);
    } catch (e) {
      data = null;
    }
    return data;
  }
}

function showSlider(eleId, maxItemWith, minItem, itemclass) {
  var p=$('#'+eleId);
  var minSlide=2;
  minItem = isNaN(minItem)?0:Number(minItem);
  if(Number(minItem) > 0) minSlide=Number(minItem);
  maxItemWith = isNaN(maxItemWith)?0:Number(maxItemWith);
  if(!Number(maxItemWith)) maxItemWith=defaultMaxItemWith;
  var slideWidth=maxItemWith;
  var viewPortWidth=$('#'+eleId).width()-20;
  var maxItems=$('#'+eleId).find(".product-cell").length;
  if(itemclass) maxItems=$('#'+eleId).find("."+itemclass).length;
  //console.log("viewPortWidth: "+viewPortWidth);
  if(viewPortWidth < sliderViewportWSwitch){slideWidth=Math.floor(viewPortWidth/minSlide);}
  var itemCount = Math.floor(viewPortWidth/maxItemWith);
  if((viewPortWidth - itemCount * maxItemWith) > maxItemWith/2){slideWidth=Math.floor(viewPortWidth/(itemCount+1));}
  var moveSlides=5;
  let window_size = $(window).width();
  if(window_size <= 992) moveSlides=3;
  if(window_size <= 600) {
    moveSlides=2;
    slideWidth = slideWidth * 0.8;
  }
  var bxCfg = {
    pager: false,
    shrinkItems: false,
    preloadImages: "all",
    hideControlOnEnd: true,
    responsive: true,
    nextText: "",
    prevText: "",
    slideMargin: 0,
    infiniteLoop: false,
    slideWidth: slideWidth,
    moveSlides: moveSlides,
    maxSlides: Math.min(maxItems,sliderMaxItems),
    minSlides: minSlide,
    touchEnabled: touchEnabled(),
    preventDefaultSwipeY: false,
    preventDefaultSwipeX: true,
    onSlideAfter: function () {
      var current = this.getCurrentSlide()+1;
      var total = this.getSlideCount();
      if (current * moveSlides >= total) {
        p.find('a.bx-next').addClass("disabled");
      }
    }
  }

  if (eleId) {
    sliderList[eleId]=$('#'+eleId).find('.product-list-slider').bxSlider(bxCfg);
    $('#'+eleId).find('.product-list-slider a').attr('rel', 'nofollow');
    return sliderList[eleId];
  }
  return null;
}


//-----------------------------------------------------------------------------
var ArticleItemBox = React.createClass({
  propTypes: {
    "data-src":React.PropTypes.string,
    url: React.PropTypes.string.isRequired,
    img_src: React.PropTypes.string.isRequired,
    img_alt: React.PropTypes.string.isRequired,
    art_title: React.PropTypes.string.isRequired
  },
  deleteItem: function(e) {
    var thisArticleCell = e.currentTarget.closest("div.content-subbox");
    var thisList = e.currentTarget.closest("div.product-list-container");
    var url=this.props.deleteUrl;
    axios({url:url,method:'DELETE',data:{articleId:this.props.articleId}}).then(function(res) {
      if(res.data && res.data.status){
        thisArticleCell.remove();
        if (!$("div.content-subbox").length) {
          thisList.style.display = "none";
        }
      }
    }).catch(function(err){
      console.log(err);
    });
  },
  componentDidMount: function() {
    $(".delete-area").on("click", function(e) {
      e.preventDefault();
    })
  },
  render: function() {
    var img_tag=h("img",{className:'c-img', src:this.props.img_src, alt:this.props.img_alt},null);
    if(this.props.islazy){
      img_tag=h("img", {className:'c-img lozad', "data-src":this.props.img_src, alt:this.props.img_alt},null);
    }
    var div = React.createFactory('div');
    var boxTitle = div({className:'content-subbox-title'},
                        h('h3',{className:'content-subbox-title'},this.props.art_title),
                        h('div',{className:'content-subbox-text'},this.props.short_desc),
                        h('div',{className:'content-subbox-author'},this.props.author));
    var aItem = React.createFactory('a');
    var delBtn = null;
    if (this.props.canDeleteItem) {
      delBtn = h('div', {className: 'delete-area', onClick: this.deleteItem},
                h('div', {className: "btn-delete", style: {"background-image": `url('${this.props.deleteImgPath}/clear_icon4x4.png')`}})
      );
    }
    return (
      h('div', {className:'content-subbox'},
        aItem({className:'content-box',href: this.props.url, title: this.props.art_title},
          h('div',{className: 'content-subbox-img'},img_tag, delBtn),boxTitle))
    );
  }
});

//-----------------------------------------------------------------------------
var SearchShopCellImage = React.createClass({
  propTypes: {
    "data-src":React.PropTypes.string,
    url: React.PropTypes.string.isRequired,
    img_src: React.PropTypes.string.isRequired,
    img_alt: React.PropTypes.string.isRequired,
    price: React.PropTypes.number.isRequired,
    n_price: React.PropTypes.number.isRequired,
    n_saleprice: React.PropTypes.number.isRequired,
    saleprice: React.PropTypes.number.isRequired,
    flashtext: React.PropTypes.string,
    fbg_color: React.PropTypes.string,
    ftext_color: React.PropTypes.string,
    is_favorite: React.PropTypes.bool,
  },
  deleteItem: function(e) {
    var thisProductCell = e.currentTarget.closest("div.product-cell");
    var thisList = e.currentTarget.closest("div.product-list-container");
    var url=this.props.deleteUrl;
    axios({url:url,method:'DELETE',data:{pId:this.props.productId}}).then(function(res) {
      if(res.data && res.data.status){
        thisProductCell.remove();
        if (!$("div.product-cell").length) {
          thisList.style.display = "none";
        }
      }
    }).catch(function(err){
      console.log(err);
    });
  },
  onPressLikeThisItem: function() {
    if (this.props.onPressLike) {
      this.props.onPressLike()
    }
  },
  componentDidMount: function() {
    $(".delete-area").on("click", function(e) {
      e.preventDefault();
    })
  },
  render: function() {
    var ft = null;
    var sb = null;
    var delBtn = null;
    var saleprice = Number(this.props.n_saleprice);
    if (saleprice > 0) {
      var price = Number(this.props.n_price);
      var this_sale = '';
      if(price != 0) this_sale = Math.round((price-saleprice)/price*100*(-1))+'%';
      if(!this.props.is_reseller){
        var bubblePosition = {};
        if (this.props.canDeleteItem) bubblePosition = {
          "top": "unset",
          "bottom": "3px"
        }
        sb = h('div', {className: 'shop-sale-bubble', style: bubblePosition }, this_sale);
      }
    }
    if (this.props.flashtext) {
      var banner_styles={};
      if(this.props.fbg_color && this.props.ftext_color){
        banner_styles = {
          "color": this.props.ftext_color,
          "background-color":this.props.fbg_color,
          "padding":"2px 4px",
          "border":"1px solid "+this.props.fbg_color,
          "border-radius":"2px",
          "background-image":
          "-webkit-linear-gradient(top,"+this.props.fbg_color+", "+this.props.fbg_color+")"
        };
      }
      ft = h('div', {className: 'shop-wrapper'},
              h('div', {className: 'ribbon-wrapper-green'},
                h('div', {className: 'ribbon-green',style:banner_styles}, this.props.flashtext)));
    }
    var img_tag = h("img", {className:'product-img', src:this.props.img_src, alt:this.props.img_alt},null);
    let { hoverImage } = this.props;
    let second_img = hoverImage ? h("img", {className:'product-second-img', src: hoverImage, alt:this.props.img_alt},null) : null;
    if(this.props.islazy){
      img_tag = h("img", {className:'product-img lozad', "data-src":this.props.img_src, alt:this.props.img_alt},null);
      second_img = hoverImage ? h("img", {className:'product-second-img lozad', "data-src": hoverImage, alt:this.props.img_alt},null) : null;
    }
    if (this.props.canDeleteItem) {
      delBtn = h('div', {className: 'delete-area', onClick: this.deleteItem},
                  h('div', {className: "btn-delete", style: {"background-image": `url('${this.props.deleteImgPath}/clear_icon4x4.png')`}})
      );
    }

    var favoriteButtonClass = this.props.is_favorite ? `favorite-button favorite-button-selected` : 'favorite-button'

    return (
      h('div', {className:'product-img'},
        h('a', {className:'product-url',href: this.props.url},
          h('div', {className: 'shop-image'},img_tag, second_img, sb, ft, delBtn),
        ),
        h('div', {className: `favorite-pid-${this.props.productId} ${favoriteButtonClass}`, onClick: this.onPressLikeThisItem, "data-pid": this.props.productId}),
      )
    );
  }
});

//-----------------------------------------------------------------------------
var SearchShopCellTitle = React.createClass({
  propTypes: {
    url: React.PropTypes.string.isRequired,
    productName: React.PropTypes.string.isRequired
  },
  render: function() {
    var code = h('div', {className:'product-title'},
                h('a',{href: this.props.url, className: "product-box-url"},
                  h('h2',{className:'product-name'}, this.props.productName)));
    if(this.props.is_reseller){
      code = h('h2', {className: 'reseller-product-title'},
                h('strong', {}, WH.messages.art_no + ": " + this.props.art_no),
                  h('br',{},null),
                    h("a", { href: this.props.url, className:"product-box-url" },
                      h('h2', { className: 'product-name' }, this.props.productName)));
    }
    return code;
  }
});

//-----------------------------------------------------------------------------
var SearchShopCellPrice = React.createClass({
  propTypes: {
    ship_alt: React.PropTypes.string.isRequired,
    ship_img: React.PropTypes.string.isRequired,
    img_src: React.PropTypes.string.isRequired,
    img_alt: React.PropTypes.string.isRequired,
    price: React.PropTypes.string.isRequired,
    saleprice: React.PropTypes.number.isRequired,
    n_saleprice: React.PropTypes.number.isRequired,
  },
  render: function () {
    let code = h('div', {className:'shop-cell-price'},
                  h('span', {className:'price'}, this.props.price),null);
    if(Number(this.props.n_saleprice) > 0){
      code = h('div', {className:'shop-cell-price'},
              h('div', {className:'prices'},
                h('span', {className:'price'},this.props.saleprice),
                h('span', {className:'sale-price'},this.props.price)),null);
    }
    if (this.props.is_reseller) {
      code = h('div', {className:'shop-cell-price'},
                h('span', {className:'price'}, this.props.price),null);
    }
    return code;
  }
});

//-----------------------------------------------------------------------------
var ShopCellButton = React.createClass({
  btnClickHandler: function(e){
    e.stopPropagation();
    switch(String(this.props.func)){
      case "add_basket":
        add2basket(e.currentTarget,this.props.product_id, this.props.inpage, this.props.price);
      break;
      case "add_basket_co":
        add2basketfromco(e.currentTarget,this.props.product_id, this.props.inpage, this.props.price);
      break;
      case "reseller_a2b":
        reseller_a2b(this.props.product_id,'new');
      break;
      case "goto_detail_page":
        location.href=`${rootUrl}/${this.props.more_info_url}`;
      break;
    }
    e.preventDefault();
  },
  render: function () {
    var btnCode=null;
    switch(Number(this.props.instock)){
      case Flag.GREEN:
      case Flag.YELLOW:
        btnCode=h('button', {className:'btn-addcart',onClick: this.btnClickHandler},this.props.btn_txt);
      break;
      case Flag.RED:
        btnCode=h('button', {className:'btn-addcart read-more',onClick: this.btnClickHandler},this.props.btn_txt);
      break;
    }
    return btnCode;
  }
});

//-----------------------------------------------------------------------------
var ShopCellSymbols = React.createClass({
  propTypes: {
      ship_alt: React.PropTypes.string.isRequired,
      ship_img: React.PropTypes.string.isRequired,
      img_src: React.PropTypes.string.isRequired,
      img_alt: React.PropTypes.string.isRequired,
  },
  render: function () {
    var code = "", tdsymbols;
    var instockImg = h('img', { className: 'instock-symbol', src: this.props.img_src, alt: this.props.img_alt, title: this.props.img_alt }, null);
    if (this.props.ship_img) {
      var freeShipImg = h('img', { className: 'img_frakt', src: this.props.ship_img, alt: this.props.ship_alt, title: this.props.ship_alt }, null);
      tdsymbols = h('div', { className: 'shop_symbols' }, instockImg, freeShipImg);
    } else {
      tdsymbols = h('div', { className: 'shop_symbols' }, instockImg);
    }
    code = tdsymbols;
    return (code);
  }
});

//-----------------------------------------------------------------------------
var ProductItemDetail = React.createClass({
  handleUserPressLikeThisItem: function () {
    // get product id
    const productId = this.props.data.product_id

    if (this.checkFavorite()) {
      // unfavorite this item
      $(`.favorite-pid-${productId}`).removeClass('favorite-button-selected')

      // call favorite API
      let url=`${rootUrl}/product/wishlist`;
      axios({url,method:'DELETE',data:{pId: productId}}).then((res) => {
        if(res.data && res.data.status) {
          // clear this product from fav list html
          $(`.prod-fv-list .product-cell.fv-item.prodid-${productId}`).remove();

          // if fav list html doesn't have any item => remove this list
          if($(`.prod-fv-list .product-cell.fv-item`).length <= 0) {
            $(`.prod-fv-list`).closest(".product-list-container").remove();
          }

          // alert event wish list changed number of items
          globalEvent.emit("wishlist-num-changed")
        }
      })
    } else {
      // favorite this item
      $(`.favorite-pid-${productId}`).addClass('favorite-button-selected')

      // call favorite API
      let url=`${rootUrl}/product/wishlist`;
      axios({url,method:'POST',data:{pId: productId}}).then((res) => {
        if(res.data && res.data.status && res.data.html) {
          // replace favorite list with new html
          $(`.prod-fv-list`).closest(".product-list-container").remove();
          $(res.data.html).insertBefore($(".wex-container .tp-slider.wh-widget"));

          // bind a remove fv action to the new list
          $("div.product-cell.fv-item button.close-btn").on("click",function(evt){
            evt.stopPropagation();
            removefromfv(this,$(this).data("pid"));
          });

          // alert event wish list changed number of items
          globalEvent.emit("wishlist-num-changed")
        }
      })
    }
  },
  // check if this product is favorited or not
  checkFavorite: function() {
    // get product id
    const productId = this.props.data.product_id

    // get list of favorite products from fav list html
    let favProductIds = []
    $("div.prod-fv-list div.product-cell button.close-btn").each(function() {
      const id = $(this).data("pid")
      favProductIds.push(id.toString())
    })

    // check if this product id is inside fav id list
    return favProductIds.includes(productId)
  },
  componentDidMount: function() {
    // update fav state when load from cached
    var self = this;
    globalEvent.on("wishlist-reload", () => {
      // get product id
      const productId = self.props.data.product_id

      var currentStatus = $(`.favorite-pid-${productId}`).hasClass("favorite-button-selected")
      var newStatus = self.checkFavorite()

      // if current status and new status (from reloaded wishlish) are difference
      // => update
      if (currentStatus !== newStatus) {
        if (newStatus === true) {
          $(`.favorite-pid-${productId}`).addClass('favorite-button-selected')
        } else {
          $(`.favorite-pid-${productId}`).removeClass('favorite-button-selected')
        }
      }
    })
  },
  render: function() {
    var is_reseller = ("reseller_a2b" == this.props.data.a2b_url);
    var is_show_symbols=this.props.data.show_symbols;
    var trSymbolDiv;
    if (!is_reseller && is_show_symbols) {
      trSymbolDiv = h(ShopCellSymbols, {
        product_id: this.props.data.product_id,
        productName: this.props.data.productName,
        img_src: this.props.data.stockImg,
        img_alt: this.props.data.stockAlt,
        is_reseller: is_reseller,
        price: this.props.data.price,
        saleprice: this.props.data.saleprice,
        ship_img: this.props.data.img_ship,
        ship_alt: this.props.data.alt_ship
      });
    }

    return (
      h('div', {className: 'product-cell', onClick: event => storeProductNavigationSession(event, this.props.data.url)},
        h('div', {className: 'product-wrapper'},
          h(SearchShopCellImage, {
            url: this.props.data.url,
            img_src: this.props.data.img_src,
            img_alt: this.props.data.img_alt,
            price: this.props.data.price,
            saleprice: this.props.data.saleprice,
            n_price: this.props.data.n_price,
            n_saleprice: this.props.data.n_saleprice,
            flashtext:this.props.data.flashtext,
            fbg_color:this.props.data.fbg_color,
            ftext_color:this.props.data.ftext_color,
            is_reseller: is_reseller,
            islazy:this.props.islazy,
            canDeleteItem:this.props.canDeleteItem,
            deleteUrl: this.props.deleteUrl,
            deleteImgPath: this.props.deleteImgPath,
            productId:this.props.data.product_id,
            hoverImage: this.props.data.hoverImage,
            onPressLike: this.handleUserPressLikeThisItem,
            is_favorite: this.checkFavorite(),
          }),
          h(SearchShopCellTitle, {
            art_no: this.props.data.art_no,
            productName: this.props.data.productName,
            url: this.props.data.url,
            is_reseller:is_reseller}),
          trSymbolDiv,
          h(SearchShopCellPrice, {
            product_id:this.props.data.product_id,
            productName: this.props.data.productName,
            img_src: this.props.data.stockImg,
            img_alt: this.props.data.stockAlt,
            is_reseller:is_reseller,
            n_price: this.props.data.n_price,
            n_saleprice: this.props.data.n_saleprice,
            price: this.props.data.price,
            n_price: this.props.data.n_price,
            n_saleprice: this.props.data.n_saleprice,
            saleprice: this.props.data.saleprice,
            ship_img:this.props.data.img_ship,
            ship_alt:this.props.data.alt_ship,
            infoUrl: this.props.data.infoUrl,
            instock:this.props.data.instock,
            func: this.props.data.a2b_url,
            product_id: this.props.data.product_id,
            btn_txt: this.props.data.a2b_btn_txt,
            btn_img: this.props.data.btn_img,
            more_info_url: this.props.data.grey_btn_url?this.props.data.grey_btn_url:this.props.data.url,
            inpage: this.props.data.inpage}),
          h(ShopCellButton, {
            product_id:this.props.data.product_id,
            func: this.props.data.a2b_url,
            price: this.props.data.n_price,
            btn_txt: this.props.data.a2b_btn_txt,
            btn_img: this.props.data.btn_img,
            more_info_url: this.props.data.grey_btn_url?this.props.data.grey_btn_url:this.props.data.url,
            instock:this.props.data.instock,
            inpage: this.props.data.inpage
          })
        )
      )
    );
  }
});
//-----------------------------------------------------------------------------
var ResellerProductType = React.createClass({
  getInitialState: function () {
    return {
      id: 0,
      numItem: 0,
      searchResults: null,
      StartNext: 1,
      isMore: false,
      page: Number(this.props.page),
      isButtonShowAll: false,
      isShowCounter: false,
      TotalSearchResults: 0
    };
  },
  doSearch: function () {
    var page = Number(this.state.page) == 0 ? 1 : Number(this.state.page);
    $.ajax({
      url: '/aspjson/products.asp?type=reseller_product_type&id=' + this.props.id + "&from=0&p="+page,
      dataType: 'json',
      cache: false,
      async: true,
      success: function (data) {
        $("div.react_loading").addClass("hide");
        if (data && data.NumofItems > 0) {
          $("#reseller_product_type").removeClass("hide");
          this.setState({isShowCounter: data.isShowCounter,isButtonShowAll: data.isButtonShowAll,TotalSearchResults: data.TotalSearchResults, searchResults: data.results, numItem: data.NumofItems, StartNext: data.StartNext, isMore: data.isMore, page: page + 1 });
        }
        else {
          $("#reseller_product_type h2").after('<div class="not-found-product">' + WH.messages.not_found_product_in_list + '</div>');
        }
      }.bind(this),
      error: function (xhr, status, err) {
        //console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  },
  doSearchMore: function (e) {
    var hostName = window.location.protocol + "//" + window.location.host + "/";
    $(".product-search-more img").removeClass("hide");
    var page = Number(this.state.page)
    $.ajax({
      url: '/aspjson/products.asp?type=reseller_product_type&id=' + this.props.id + "&from=" + this.state.StartNext+"&p="+page,
      dataType: 'json',
      cache: false,
      success: function (data) {
        if (data && data.NumofItems > 0) {
          var results = this.state.searchResults.concat(data.results);
          var num = this.state.numItem + data.NumofItems;
          this.setState({isShowCounter: data.isShowCounter,isButtonShowAll: data.isButtonShowAll,TotalSearchResults: data.TotalSearchResults, searchResults: results, numItem: num, StartNext: data.StartNext, isMore: data.isMore, page: page + 1 });
        }
        else {
          this.setState({ isMore: false });
        }
        $(".product-search-more img").addClass("hide");
        update_paging_cache("p_reseller_type",this.state.page);
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  },
  doSearchAll: function (e) {
    var hostName = window.location.protocol + "//" + window.location.host + "/";
    $(".product-search-all img").removeClass("hide");
    var page = Number(this.state.page)
    $.ajax({
      url: '/aspjson/products.asp?type=reseller_product_type&id=' + this.props.id + "&from=" + this.state.StartNext+"&p="+page+"&all=true",
      dataType: 'json',
      cache: false,
      success: function (data) {
        if (data && data.NumofItems > 0) {
          var results = this.state.searchResults.concat(data.results);
          var num = this.state.numItem + data.NumofItems;
          this.setState({isShowCounter: data.isShowCounter,isButtonShowAll: data.isButtonShowAll,TotalSearchResults: data.TotalSearchResults, searchResults: results, numItem: num, StartNext: data.StartNext, isMore: data.isMore, page: page + 1 });
        }
        else {
          this.setState({ isMore: false });
        }
        $(".product-search-all img").addClass("hide");
        update_paging_cache("p_reseller_type",this.state.page);
      }.bind(this),
      error: function (xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  },
  componentDidMount: function () {
    this.doSearch();
  },
  componentWillUnmount: function () {
    $("#searchpic_desktop")[0].removeEventListener('click', this.doSearch);
    $("#searchpic_mobile")[0].removeEventListener('click', this.doSearch);
  },
  componentDidUpdate : function () {
    _fillUpProducts();
    ScrollToPostion();
  },
  render: function () {
    var SearchNodes = "";
    if (this.state.searchResults) {
      SearchNodes = this.state.searchResults.map(function (searchItem) {
        return (h(ProductItemDetail, { data: searchItem, key: searchItem.product_id }));
      });
    }
    var showMoreB = this.state.isMore ? 'product-search-more' : 'product-search-more hide';
    var showMoreB_all = this.state.isMore ? 'product-search-all' : 'product-search-all hide';
    var div = React.createFactory('div'), divSearch = React.createFactory('div');
    var sm = "";
    var sm1 = "";
    var sp = div({ className: 'product_result_container' },
    h('h2', { className: 'product_result' }, this.props.title),SearchNodes);
    if (this.state.isMore) {
      sm = div({ className: showMoreB, onClick: this.doSearchMore},
        h('span', {}, WH.messages.show_more),
        h('img', { className: 'hide', src: '/images/ajax-loader_24x24.gif' }));
      if (this.state.isShowCounter && this.state.searchResults.length<this.state.TotalSearchResults){
        sm = div({ className: showMoreB, onClick: this.doSearchMore},
          h('span', {}, WH.messages.show_more," ", this.state.TotalSearchResults-this.state.searchResults.length," ",WH.messages.products),
          h('img', { className: 'hide', src: '/images/ajax-loader_24x24.gif' }));
      }
      if (this.state.isButtonShowAll){
        sm1 = div(
          {className: showMoreB_all, onClick: this.doSearchAll },
          h('span', {}, WH.messages.show_all),
          h('img', { className: 'hide', src: '/images/ajax-loader_24x24.gif' }));
      }
    }
    if (sm1){
      return (divSearch({ className: 'product_search_container' }, sp, sm, sm1));
    }
    else{
      return (divSearch({ className: 'product_search_container' }, sp, sm));
    }

  }
});
//-----------------------------------------------------------------------------
var ProductList = React.createClass({
  getInitialState: function () {
    return {
      id: 0,
      type: "category",
      numItem: 0,
      searchResults: null,
      StartNext: 0,
      isMore: false,
      page : Number(this.props.page),
      html:"",
      isButtonShowAll: false,
      isShowCounter: false,
      TotalSearchResults: 0
    };
  },
  doSearch: function () {
    var page=Number(this.state.page)==0?1:Number(this.state.page);
    var url = this.props.ajax_url;
    url += (url.indexOf("?") !== -1)?"&":"?";
    url += "p="+page + "&isback=1";
    const _self=this;
    axios({url:url,method:'GET'}).then(function(res) {
        let data = res.data;
        if (data && data.NumofItems > 0) {
          _self.setState({
            TotalSearchResults: data.TotalSearchResults,
            isShowCounter: data.isShowCounter,
            isButtonShowAll: data.isButtonShowAll,
            searchResults:data.results,
            numItem: data.NumofItems,
            StartNext: data.StartNext+data.NumofItems,
            isMore: data.isMore,
            page:data.page});
        } else {
          $("#product_topsales h2").after('<div class="not-found-product">' + 'Not found' + '</div>');
        }
      }).catch(function(err){
        console.log(err);
      });
  },
  doSearchMore: function (e) {
    var page=Number(this.state.page)+1;
    var url = this.props.ajax_url;
    url += (url.indexOf("?") !== -1)?"&":"?";
    url += "p="+page;
    $(".product-search-more img").removeClass("hide");
    $.ajax({
      url: url,
      dataType: 'json',
      type: 'GET',
      success: function (data) {
        if (data && data.NumofItems > 0) {
          var results = this.state.searchResults.concat(data.results);
          this.setState({isShowCounter: data.isShowCounter,isButtonShowAll: data.isButtonShowAll,TotalSearchResults: data.TotalSearchResults, searchResults: results,isMore:data.isMore, page:data.page});
        } else {
          this.setState({ isMore: false });
        }
        $(".product-search-more img").addClass("hide");
        update_paging_cache("p_ts_"+this.props.type,page);
      }.bind(this),
      error: function (xhr, status, err) {
      }.bind(this)
    });
  },
  doSearchAll: function (e) {
    var page=-1;
    var url = this.props.ajax_url;
    url += (url.indexOf("?") !== -1)?"&":"?";
    url += "p="+page;
    $(".product-search-all img").removeClass("hide");
    $.ajax({
      url: url,
      dataType: 'json',
      type: 'GET',
      success: function (data) {
        if (data && data.NumofItems > 0) {
          var results = data.results;
          this.setState({isShowCounter: data.isShowCounter, isButtonShowAll: data.isButtonShowAll, TotalSearchResults: data.TotalSearchResults, searchResults: results,isMore:data.isMore, page:data.page});
        } else {
          this.setState({ isMore: false });
        }
        $(".product-search-all img").addClass("hide");
        update_paging_cache("p_ts_"+this.props.type,page);
      }.bind(this),
      error: function (xhr, status, err) {
      }.bind(this)
    });
  },
  componentDidMount: function () {
    this.doSearch();
  },
  componentDidUpdate : function () {
  },
  componentWillUnmount: function () {
    $("#searchpic_desktop")[0].removeEventListener('click', this.doSearch);
    $("#searchpic_mobile")[0].removeEventListener('click', this.doSearch);
  },
  render: function () {
    var SearchNodes = null;//h(ProductBoxes,{html: this.state.html});
    if (this.state.searchResults) {
      SearchNodes = this.state.searchResults.map(function (searchItem) {
        return (h(ProductItemDetail, { data: searchItem, key: searchItem.product_id }));
      });
    }
    var showMoreB = this.state.isMore ? 'product-search-more' : 'product-search-more hide';
    var showMoreB_all = this.state.isMore ? 'product-search-all' : 'product-search-all hide';
    var div = React.createFactory('div'), divSearch = React.createFactory('div');
    var sm = null;
    var sm1 = null;
    var sp = div({ className: 'product_result_container' },SearchNodes);
    if (this.state.isMore) {
      sm = div({ className: showMoreB, onClick: this.doSearchMore},
      h('span', {}, "More..."),
      h('img', { className: 'hide', src: '/images/ajax-loader_24x24.gif' }));
        if (this.state.isShowCounter && this.state.searchResults.length<this.state.TotalSearchResults){
          sm = div({ className: showMoreB, onClick: this.doSearchMore},
            h('span', {}, "More..."," ", this.state.TotalSearchResults-this.state.searchResults.length," ","products"),
            h('img', { className: 'hide', src: '/images/ajax-loader_24x24.gif' }));
        }
        if (this.state.isButtonShowAll){
          sm1 = div(
            {className: showMoreB_all, onClick: this.doSearchAll },
            h('span', {}, "Show all"),
            h('img', { className: 'hide', src: '/images/ajax-loader_24x24.gif' }));
        }
      }
      if (sm1){
        return (divSearch({ className: 'product_search_container' },h('h2', { className: 'product_result' }, this.props.title),sp, sm, sm1));
      }
      else{
        return (divSearch({ className: 'product_search_container' },h('h2', { className: 'product_result' }, this.props.title),sp, sm));
      }
    }
});

//-----------------------------------------------------------------------------
var ProductType = React.createClass({
  getInitialState: function () {
    return {
      id: 0,
      sort: this.props.defaultSort || "margin",
      availability: parseInt(this.props.availability) || 0,
      searchResults: null,
      page:1,
      isShowAll: true,
      total: 0,
      sortopts: null,
      first_page: 50,
      no_item_text: ""
    };
  },
  doSearch: function () {
    const _self=this;
    this.state.sortopts=this.props.sortopts;
    let dataObj = getPagingFromSession(`paging_${document.location.pathname}`);
    if(!dataObj) dataObj={url: this.props.url,method: 'POST',data:{product_type_id:this.props.ptype_id, page: 1, count: 50, first_page: this.state.first_page, sortby: this.state.sort}};
    else { dataObj.data = dataObj.data || {}; dataObj.data.isBack=true;}

    dataObj.data.sortby = _self.state.sort;
    dataObj.data.availability = _self.state.availability;
    dataObj.data.first_load = 1;

    axios(dataObj).then(function (res) {
      var data = res.data;
      if (data && Number(data.count) >= 0) {
        _self.setState({
          url: _self.props.url,
          id: _self.props.ptype_id,
          count: data.count,
          total: data.total,
          page: data.page,
          searchResults: data.products,
          isShowAll: data.isMore,
          sort: _self.state.sort,
          productNavs: data.productNavs,
          no_item_text: data.no_item_text
        });
      }
      storePaging2Session(dataObj);
      if(Number(dataObj.data.pos) >= 0) $(window).scrollTop(Number(dataObj.data.pos));
    }).catch(function(err){
      console.error(err);
    })
  },
  doSort: function (field) {
    const _self=this;
    const dataObj = {url: this.state.url,method: 'POST',data:{product_type_id:this.state.id, page: 1, count: 50, first_page: this.state.first_page, sortby: field, oldsort: this.state.sort}};

    dataObj.data.availability = _self.state.availability;

    axios(dataObj).then(function (res) {
      var data = res.data;
      if (data && Number(data.count) >= 0) {
        _self.setState({
          url: _self.props.url,
          id: _self.props.ptype_id,
          count: data.count,
          total: data.total,
          page: data.page,
          searchResults: data.products,
          isShowAll: data.isMore,
          sort: data.sortby,
          productNavs: data.productNavs,
          no_item_text: data.no_item_text
        });
      }
      storePaging2Session(dataObj);
    }).catch(function(err){
      console.error(err);
    })
  },
  doFilter: function () {
    $.ajax({
      url: '/aspjson/products.asp?type=product_type&id='+this.props.id+'&ptype='+this.props.ptype+'&sort='+this.props.sort+'&from=0'+'&to='+this.state.StartNext+"&p="+this.state.page,
      dataType: 'json',
      cache: false,
      async: true,
      success: function (data) {
        if (data && data.NumofItems > 0) {
          $("#product_producttype").removeClass("hide");
          this.setState({isShowCounter: data.isShowCounter, isButtonShowAll: data.isButtonShowAll, TotalSearchResults: data.TotalSearchResults,searchResults: data.results, numItem: data.NumofItems, StartNext: data.StartNext, isMore: (!this.state.isMore ? false : data.isMore)});
        }
      }.bind(this),
      error: function (xhr, status, err) {
      //console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  },
  doSearchAll: function (e) {
    const _self=this;
    const dataObj = {url: this.state.url,method: 'POST',data:{product_type_id:this.state.id, page: 2,sortby: this.state.sort}};

    dataObj.data.availability = _self.state.availability;

    axios(dataObj).then(function (res) {
      var data = res.data;
      if (data && Number(data.count) >= 0) {
        _self.setState({
          total: data.total,
          count: data.count,
          searchResults: data.products,
          isShowAll: false,
          sort: data.sortby,
          page: 2,
          productNavs: data.productNavs,
          no_item_text: data.no_item_text
        });
      }
      storePaging2Session(dataObj);
    }).catch(function(err){
      console.error(err);
    })
  },
  doSearchMore: function (e) {
    const _self=this;
    let curPage = e.target.getAttribute("data-cur-page");
    curPage = Number(curPage)+1;
    let total = 0;
    if(this.state.hasOwnProperty("total"))  total=Number(this.state.total);

    const dataObj = {url: this.state.url,method: 'POST',data:{product_type_id:this.state.id, page: curPage, count: 100, first_page: this.state.first_page, total: total, sortby: this.state.sort}};

    dataObj.data.availability = _self.state.availability;

    axios(dataObj).then(function (res) {
      var data = res.data;
      _self.setState({
        no_item_text: data || data.no_item_text
      });

      if (data && Number(data.count) >= 0) {
        _self.setState({
          total: Number(data.total),
          count: data.count,
          searchResults: _self.state.searchResults.concat(data.products),
          isShowAll: data.isMore,
          sort: data.sortby,
          page: data.page
        });
      }
      storePaging2Session(dataObj);
    }).catch(function(err){
      console.error(err);
    })
  },
  componentDidMount: function () {
    this.doSearch();
  },
  componentDidUpdate : function () {
    //ScrollToPostion();
    //_fillUpProducts();
    const observer=lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  },
  componentWillUnmount: function () {
    $("#searchpic_desktop")[0].removeEventListener('click', this.doSearch);
    $("#searchpic_mobile")[0].removeEventListener('click', this.doSearch);
  },
  render: function () {
    var SearchNodes="";
    var productNavs = null;
    if (this.state.searchResults) {
      try {
        if (this.state.productNavs && this.state.productNavs.length) productNavs = h("div", {className: "product-nav-all"}, JSON.stringify(this.state.productNavs));
      } catch (e) {
        console.error(e);
      }
      if (this.state.productNavs && this.state.productNavs.length) {
        SearchNodes = [productNavs, this.state.searchResults.map(function (searchItem) {
          return (h(ProductItemDetail, { data: searchItem, key: searchItem.product_id,islazy: lazyLoadProdImg }));
        })];
      } else SearchNodes = this.state.searchResults.map(function (searchItem) {
        return (h(ProductItemDetail, { data: searchItem, key: searchItem.product_id,islazy: lazyLoadProdImg }));
      });
    }
    var div = React.createFactory('div'), divSearch = React.createFactory('div'), but=React.createFactory('button');
    var showAllBtn=null;
    var sp=null;
    var divSort=null;
    if(this.props.isSortable && this.state.count > 0){
      var sorted=this.state.sort;
      var sortOpts=this.state.sortopts || {};
      var aSortLatest, aSortPrice, aSortName,aAvailability;
      aAvailability = h('a', { className: (sorted == 'availability' ? 'sorted' : 'sortable'), onClick: this.doSort.bind(this,'availability',-1)},sortOpts['availability'] || 'availability');
      aSortLatest = h('a', { className: (sorted == 'latest' ? 'sorted' : 'sortable'), onClick: this.doSort.bind(this, 'latest', -1) }, sortOpts['latest'] || 'latest');
      aSortPrice = h('a', { className: (sorted == 'price' ? 'sorted' : 'sortable'), onClick: this.doSort.bind(this, 'price', -1) }, sortOpts['price'] || 'price');
      aSortName = h('a', { className: (sorted == 'name' ? 'sorted' : 'sortable'), onClick: this.doSort.bind(this, 'name', -1) }, sortOpts['name'] || 'name');
      divSort = h('div', { className: 'product-sort' }, aAvailability,aSortName,aSortLatest,aSortPrice);
    }
    if(SearchNodes) {
      sp=div({className:'product-list-container'},divSort,h('div',{className:'prodtype-list'},SearchNodes));
    }else sp=div({className:'product-list-container'},h('div',{className:'prodtype-list'},this.state.no_item_text));
    if (this.state.isShowAll && this.state.count > 0){
      let itemNum = Number(this.state.count);
      if(Number(itemNum) <= 100){
        itemNum = Number(this.state.count)*Number(this.state.page);
        if(Number(this.state.page) > 1) itemNum = Number(itemNum)-Number(this.state.first_page);
      }
      showAllBtn=div({className: 'showall-btn'},h('span',{className: 'info'},`Visar ${itemNum} av ${this.state.total}`), but({onClick: this.doSearchMore,"data-cur-page": this.state.page},this.props.showAll,h("i",{className:'hide fas fa-angle-double-right'})),
          h('img',{className: 'hide', src: '/images/ajax-loader_24x24.gif'}));
    }
    if (showAllBtn){
      return div({className:'product-list-container'},divSort,h('div',{className:'prodtype-list'},SearchNodes),showAllBtn);
    }
    return sp;
  }
});
//-----------------------------------------------------------------------------
var ProductScrollList = React.createClass({
  getInitialState: function () {
    return {numItem:0,searchResults:null, url:null,method:"GET",no_item_text:"No product list!"};
  },
  doChange: function (url) {
    const _self=this;
    axios({url: url,method: this.state.method}).then(function (res) {
      let data = res.data;
      if (data && data.NumofItems > 0) {
        if(sliderList && sliderList[_self.props.ele_id]) sliderList[_self.props.ele_id].destroySlider();
        _self.setState({searchResults: data.results, numItem: data.NumofItems, url: url, no_item_text: data.no_item_text});
      }
    }).catch(function (err) {
      console.log(err);
    });
  },
  doSearch: function () {
    const _self=this;
    axios({
      url: this.props.ajax_url,
      method: this.props.method?this.props.method:"GET"}).then(
        function (res) {
          let data = res.data;
          if (data) {
            let numItem = data.NumofItems?data.NumofItems:data.total;
            let products = data.results;
            if(!products) products = data.products;
            _self.setState({searchResults: products, numItem: numItem, url: _self.props.ajax_url,method: _self.props.method,no_item_text: data.no_item_text});
          }
        }).catch(function (err) {
          console.log(err);
        });
  },
  componentDidMount: function () {
    this.doSearch();
  },
  componentDidUpdate: function () {
    const observer=lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
    if(!this.props.notCreatedSlider && this.state.numItem > 0) showSlider(this.props.ele_id, this.props.width || "");
  },
  render: function () {
    var SearchNodes = "";
    let headerlist = '';
    var canDeleteItem = this.props.canDeleteItem;
    var deleteUrl = this.props.deleteUrl;
    var deleteImgPath = this.props.deleteImgPath;
    if (this.state.searchResults && this.state.numItem > 0) {
      SearchNodes = this.state.searchResults.map(function (searchItem) {
        return (h(ProductItemDetail, {
          data: searchItem,
          key: searchItem.product_id,
          islazy: lazyLoadProdImg,
          canDeleteItem: canDeleteItem,
          deleteUrl: deleteUrl,
          deleteImgPath: deleteImgPath
        }));
      });
      var div = React.createFactory('div'), divSearch = React.createFactory('div');
      var h2 = null, show_all=null, sp=null;
      if(this.props.title) h2 = h('h2', { className: 'title' }, this.props.title);

      if(this.props.isShowAll){
        show_all=h('a',{className:'btn',href:this.props.showall_url},this.props.showAll);
      }
      if (h2) {
        headerlist = div({ className: 'product-list-header' }, h2, show_all);
      }
      sp = div({className: 'product-list-slider no-item'}, this.state.no_item_text);
      if (this.state.numItem > 0) {
        var productsNav = null;
        try {
          productsNav = JSON.stringify(this.state.searchResults.map(item => ({
            product_id: item?.product_id,
            url: item?.url
          })))
        } catch (e) {
          console.error(e);
        }
        if (productsNav.length) {
          sp = [div({ className: 'product-list-slider'}, SearchNodes ), div({className: "product-nav-all"}, JSON.stringify(this.state.searchResults.map(item => ({
            product_id: item?.product_id,
            url: item?.url
          }))))];
        } else sp = div({ className: 'product-list-slider'}, SearchNodes);
      }
      return (divSearch({ className: 'product-list-container' }, headerlist,sp));
    }
    return null;
  }
});

//-----------------------------------------------------------------------------
var ArticleScrollList = React.createClass({
  getInitialState: function () {
    return {numItem:0,articles:null,url:null,method:"GET"};
  },
  doSearch: function () {
    const _self=this;
    axios({
      url: this.props.url,
      method: this.props.method?this.props.method:"GET"
    }).then(function (res) {
      let data=res.data;
      if (data) {
       _self.setState({articles: data.articles, numItem: data.numItem, url: _self.props.url,method: _self.props.method});
      }
    }).catch(function (err) {
      console.log(err);
    });
  },
  componentDidMount: function () {
    this.doSearch();
  },
  componentDidUpdate: function () {
    if(!this.props.notCreatedSlider) showSlider(this.props.ele_id, this.props.itemWidth,this.props.minSlides,"content-subbox");
    const observer=lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  },
  render: function () {
    var SearchNodes="";
    var canDeleteItem = this.props.canDeleteItem;
    var deleteUrl = this.props.deleteUrl;
    var deleteImgPath = this.props.deleteImgPath;
    if (this.state.articles) {
      SearchNodes = this.state.articles.map(function (it) {
        return (h(ArticleItemBox, {
          url: it.url,
          img_src: it.img_src,
          img_alt: it.img_alt,
          art_title: it.art_title,
          key: it.content_id,
          islazy: lazyLoadCntImg,
          canDeleteItem: canDeleteItem,
          deleteUrl: deleteUrl,
          deleteImgPath: deleteImgPath,
          articleId: it.content_id
        }));
      });
      var div = React.createFactory('div'), divSearch = React.createFactory('div');
      var h2 = null, show_all=null, sp=null;
      if(this.props.title) h2 = h('h2', { className: 'title' }, this.props.title);

      if(this.props.isShowAll){
        show_all=h('a',{className:'btn',href:this.props.showall_url},this.props.showAll);
      }
      var headerlist = div({ className: 'product-list-header'}, h2, show_all);
      if (this.state.numItem > 0) {
        sp = div({ className: 'product-list-slider'}, SearchNodes);
      }
      return (divSearch({ className: 'product-list-container' }, headerlist,sp));
    }
    return null;
  }
});

function bindNotifyStockEvents(){
  $(".stock-avail button.cl-close-btn").on("click", function(evt){
    evt.stopPropagation();
    $("#notifyStockSub").remove();
  });
  $(".stock-avail button[name='subs_NotifyStock']").on("click", function(evt){
    evt.stopPropagation();
    notifyStockSubscribe(this);
  });
}

function notifyStockSubscribe(ele) {

  let pId = $(ele).data("pid");
  let email = $("#notifyStockSub").find("input[name='subs_email']").val();
  if(!EmailValidator.validate(email)){
    $("#notifyStockSub div.cl-error").html(`${$("input[name='subs_email']").data("invalid-msg")}`);
    return;
  }

  let url=`${rootUrl}/product/notifystock`;
  axios({url:url,method:'POST',data:{pId:pId,email:email}}).then(function(res) {
    let data = res.data;
    $("#notifyStockSub").find("div.cl-error").html(data.errorMsg);
    $(ele).html($(ele).data("close-txt"));
    $(ele).on("click", function(evt){
      evt.stopPropagation();
      $("#notifyStockSub").remove();
    });
  }).catch(function(err){
    console.log(err);
  });
}

function loadNotifyStockPopup(ele){
  let pId = $(ele).data("pid");
  let url=`${rootUrl}/product/notifystock?pId=${pId}`;
  axios({url:url,method:'GET'}).then(function(res) {
    let data = res.data;
    $("#notifyStockSub").remove();
    if(data && data.html){
      $(data.html).insertAfter($("div.super-menu"));
      bindNotifyStockEvents();
    }
  }).catch(function(err){
    console.log(err);
  });
}

function setProductNavigation(event) {
  try {
    let ele = $(event.target).parents().siblings().closest("div.product-nav-all");
    if (!ele) return;
    const productNavs = JSON.stringify(JSON.parse(ele.text()));
    if (!productNavs.length) return;
    sessionStorage.setItem("productNavs", productNavs);
  } catch (e) {
    console.error(e);
  }
}

var InstagramImageGrid = React.createClass({
  getInitialState: function () {
    return {searchResults:null};
  },
  doSearch: function () {
    const _self=this;
    axios({
      url: `/instagram-grid`,
      method: "GET"
    }).then(
        function (res) {
          if (res.data && res.data.data) {
            _self.setState({searchResults: res.data.data});
          }
        }).catch(function (err) {
          console.log(err);
        });
  },
  onClickHandle: function (e) {
    navigator.sendBeacon(`/instagram-grid/clicked?instagram_image_id=${e.currentTarget.id}`);
  },
  componentDidMount: function () {
    this.doSearch();
  },
  componentDidUpdate: function () {
    const observer=lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();
  },
  render: function () {
    const self = this;
    if (!this.state.searchResults || !this.state.searchResults.length) return null;
    return (
      h('div', {className: 'instagram-grid-content'},
        this.state.searchResults.map(function (searchItem) {
          return (
            h('a',{className: 'ins-item', href: searchItem.image_href, id: searchItem.instagram_image_id, onClick: self.onClickHandle},
              searchItem.image_href != '' ? h('img',{className: `ins-btn-link lozad`, 'data-src': `${window.location.origin}/images/ins-link-icon.png`}) : '',
              h('img',{
                className: 'ins-img lozad',
                'data-src': `${window.location.origin}/${searchItem.image_url}`,
                alt: searchItem.image_alt
              }, null)  
            )
          )
        })
      )
    )
  }
});

export {ProductList,ProductScrollList,ProductType, sliderList,showSlider,ArticleScrollList,loadNotifyStockPopup,setProductNavigation,storeProductNavigationSession,getProductNavigationSession,InstagramImageGrid};
